module.exports = __webpack_public_path__ + "static/media/DMG-Dark.4f2dce91.webp";